<template>
  <v-container>
    <v-data-table
      ref="table"
      :v-if="selectedSerialNumber"
      :loading="loading"
      :headers="headers"
      :items="counters"
      sort-by="name"
      class="elevation-1"
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ $t("Counters") }}</v-toolbar-title>
        </v-toolbar>

        <v-container>
          <v-row align="center">
            <v-col cols="12" sm="4">
              <v-select
                :items="clients"
                v-model="clientsFilterValue"
                item-text="name"
                clearable
                :label="$t('Customer')"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                ref="devicesMenu"
                v-model="deviceSerialNumber"
                :items="deviceSerialNumberValue"
                clearable
                small-chips
                item-text="serial_number"
                :label="`${$t('Serial number')} *`"
                multiple
                :error-messages="
                  errorMessage ? $t('Please select serial numbers') : ''
                "
              >
                <template v-slot:prepend-item>
                  <v-btn class="ml-4 my-2" outlined @click="selectAll" small>{{
                    $t("Select all")
                  }}</v-btn>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12" sm="2">
              <v-select
                :items="applications"
                v-model="applicationsFilterValue"
                item-text="name"
                item-value="id"
                clearable
                :label="$t('Applications')"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="5" lg="3" xl="2">
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDate"
                    :label="$t('Start date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  scrollable
                  @input="startDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="5" lg="3" xl="2">
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endDate"
                    :label="$t('End date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  scrollable
                  @input="endDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="3" lg="2">
              <v-btn
                depressed
                color="primary"
                :loading="loading"
                @click="fetchCounters"
                >{{ $t("Search") }}</v-btn
              >
            </v-col>
            <v-col cols="6" sm="3" lg="2">
              <v-btn
                depressed
                color="secondary"
                outlined
                :loading="loadingExport"
                @click="exportCounters"
                >{{ $t("Export") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.created_at="{ item }">{{
        $d(Date.parse(item.created_at), "short")
      }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import counters from "@/api/counters";
import FileDownload from "js-file-download";

export default {
  name: "Compteurs",
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      loadingExport: false,
      dialog: false,
      attachLicenceDialog: false,
      renewLicenceDialog: false,
      search: "",
      clientsFilterValue: "",
      entitiesFilterValue: "",
      applicationsFilterValue: "",
      deviceFilterValue: "",
      selectedSerialNumber: false,
      deviceSerialNumber: [],
      filterBoolean: false,
      errorMessage: false,
      startDateMenu: false,
      endDateMenu: false,
      startDate: null,
      endDate: null,
    };
  },
  computed: {
    ...mapState({
      licences: (state) => state.licences.items,
      reseller: (state) => state.auth.user.id,
      clients: (state) => state.clients.items,
      applications: (state) => state.applications.items,
      counters: (state) => state.counters.items,
    }),
    deviceSerialNumberValue() {
      let result = [];
      this.licences.forEach((licence) => {
        if (
          licence.serial_number != null &&
          (this.clientsFilterValue == "" ||
            licence.client?.name == this.clientsFilterValue ||
            this.clientsFilterValue == undefined)
        ) {
          result.push(licence.serial_number);
        }
      });
      return result;
    },
    headers() {
      return [
        {
          text: this.$t("Application"),
          align: "start",
          sortable: true,
          value: "licence.application.name",
          filter: this.applicationsFilter,
        },
        {
          text: this.$t("Serial number"),
          align: "start",
          sortable: true,
          value: "licence.serial_number",
        },
        {
          text: this.$t("Customer"),
          align: "start",
          sortable: true,
          value: "licence.client.name",
          filter: this.clientsFilter,
        },
        {
          text: this.$t("Date"),
          align: "start",
          sortable: true,
          value: "created_at",
          filter: this.datesFilter,
        },
        {
          text: this.$t("Counters"),
          align: "start",
          sortable: true,
          value: "count",
        },
      ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    if (this.licences.length === 0) {
      this.loading = true;
      this.$store
        .dispatch("licences/fetchAll")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
    }
  },
  methods: {
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$store.dispatch("licences/resetEditedItem");
      }, 300);
    },
    clientsFilter(value, search, item) {
      if (!this.clientsFilterValue) {
        return true;
      }
      return item.licence.client?.name
        .toLowerCase()
        .includes(this.clientsFilterValue.toLowerCase());
    },
    applicationsFilter(value, search, item) {
      if (!this.applicationsFilterValue) {
        return true;
      }
      return item.licence.application.id === this.applicationsFilterValue;
    },
    datesFilter(value) {
      if (!this.startDate && !this.endDate) {
        return true;
      }

      return (
        (!this.startDate || value > this.startDate) &&
        (!this.endDate || value < this.endDate)
      );
    },
    fetchCounters() {
      this.loading = true;
      this.$store
        .dispatch("counters/fetchAll", {
          devices: this.deviceSerialNumber,
          application: this.applicationsFilterValue,
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then(() => ((this.loading = false), (this.errorMessage = false)))
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            this.errorMessage = true;
          } else {
            this.snackbar("error", this.$t("snackbar-message-counters.error"));
          }
          this.loading = false;
        });
    },
    exportCounters() {
      this.loadingExport = true;

      let data = {
        devices: this.deviceSerialNumber,
        ...(this.applicationsFilterValue && {
          application_id: this.applicationsFilterValue,
        }),
        ...(this.startDate && { start_date: this.startDate }),
        ...(this.endDate && { end_date: this.endDate }),
      };

      counters
        .export(data)
        .then((response) => {
          this.loadingExport = false;
          FileDownload(response.data, `tbc-counters.xlsx`);
        })
        .catch(() => {
          this.loadingExport = false;
        });
    },
    selectAll() {
      this.deviceSerialNumber = [...this.deviceSerialNumberValue];
      this.$refs.devicesMenu.isMenuActive = false;
    },
  },
};
</script>